import { Stack } from "@mui/material";
import type { FC } from "react";
import { AssociatedFilesDialog } from "./AssociatedFilesDialog";
import type { AssociatedFile } from "./AssociatedFilesView";
import { AssociatedFilesView } from "./AssociatedFilesView";

interface Props {
  readonly values: AssociatedFile[];
  readonly maxFiles?: number;
  readonly addButtonTooltip?: string;
  readonly hideFilename?: boolean;
  readonly onNewFile: (formData: FormData) => void | Promise<void>;
  readonly onRemoveFile: (idx: number) => void | Promise<void>;
}

export const AssociatedFilesEdit: FC<Props> = ({
  values,
  maxFiles,
  addButtonTooltip,
  hideFilename,
  onNewFile,
  onRemoveFile,
}) => {
  const addDisabled = maxFiles && values.length >= maxFiles;
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
      }}
    >
      {!addDisabled && (
        <AssociatedFilesDialog buttonTooltip={addButtonTooltip} hideFilename={hideFilename} onNewFile={onNewFile} />
      )}
      <AssociatedFilesView values={values} onRemove={onRemoveFile} />
    </Stack>
  );
};
